"use client"

import { createContext } from "react"

/**
 * Note: Still used by components generated by old versions of Framer
 *
 * @deprecated
 */
export const DeprecatedLayoutGroupContext = createContext<string | null>(null)
